<template>
    <div class="timelineitem">
        <v-timeline-item hide-dot class="pb-0">
            <span class="overline">{{fecha}}</span>
            <span class="overline grey--text ml-2">{{time}}</span>
        </v-timeline-item>

        <v-timeline-item class="mb-4" color="grey" icon-color="red lighten-2" small>
            <v-row justify="space-between">
            <v-col cols="12">
                <VChip color="gray" small class="mr-2 mb-2">{{ver}}</VChip>
                <ul class="mt-5 pl-0 caption font-weight-light">
                <li v-for="(cambio, i) in cambios" :key="i">{{cambio}}</li>
                </ul>
            </v-col>
            </v-row>
        </v-timeline-item>
    </div>
</template>

<script>
export default {
    props: ['ver', 'fecha', 'time', 'descripcion'],
    computed:{
        cambios(){
            return this.descripcion.split("\n")
        }
    }
}
</script>